module.exports = __webpack_public_path__ + "img/组7@2x.003dac3e.png";